import { Button, Collapse, message, Modal, Spin, Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import './index.css';
import {
  getCustomerStorageOrders,
  getCustomerStorageSubscriptions,
  packageOrderData,
  getCustomerByEmail,
  getStorageOrdersByEmail,
  getCustomerAlaCarteOrders,
  getRentalAlaCarteOrders,
} from '../../../../data/API';
import { getMyData } from '../../../../utils/token';
import { DownOutlined, UpOutlined, UserOutlined, MailOutlined, PhoneOutlined, EditOutlined, CalendarOutlined, ClockCircleOutlined, InboxOutlined } from '@ant-design/icons';

import EditCustomerModal from './components/EditCustomerModal';
import DateChangeModal from './components/DateChangeModal';
import ExtendRentalModal from './components/ExtendRentalModal';
import RentalExtensionSummaryModal from './components/RentalExtensionSummaryModal';
import ExtensionSuccessModal from './components/ExtensionSuccessModal';

const { Panel } = Collapse;
const { TabPane } = Tabs;

const Account = (props) => {
  const [orders, setOrders] = useState({
    currentPage: 1,
    limit: 4,
    orders: [],
    pages: 0,
    storageOrders: [],
    storageCurrentPage: 1,
    storagePages: 0,
    storageTotalCount: 0,
    hasStorageAccount: false
  });
  const [subscriptions, setSubscriptions] = useState({
    currentPage: 1,
    limit: 4,
    subscriptions: [],
    pages: 0
  });
  const [alaCarteOrders, setAlaCarteOrders] = useState({
    orders: [],
    totalCount: 0,
    loading: false,
    byRentalOrder: {}  // Map of rentalOrderId -> [alaCarteOrders]
  });
  const [showLoader, setShowLoader] = useState(false);
  const [expandedSubscriptions, setExpandedSubscriptions] = useState({});
  const [modalStates, setModalStates] = useState({
    editCustomer: false,
    dateChange: false,
    extendRental: false,
    orderSummary: false
  });

  const [rentalData, setRentalData] = useState({
    selectedOrder: null,
    selectedExtendOrder: null,
    selectedOrderDetails: null,
    extensionSummaryData: null,
    loadingOrderDetails: false,
    isProcessing: false
  });

  const [extensionSuccess, setExtensionSuccess] = useState({
    show: false,
    data: null
  });

  let { customerData, getUserData, extraWork, handleOrderUpdate, handleStorageAccountUpdate } = props;
  const { user } = useSelector((state) => state.auth);
  let customer = getMyData();
  const location = useLocation();
  const navigate = useNavigate();

  const getUserTypeFromToken = () => {
    try {
      const token = localStorage.getItem('token') || customerData?.token;
      if (!token) {
        console.warn('No token found, defaulting to customer');
        return 'customer';
      }
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.type;
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'customer';
    }
  };

  const isStorageCustomer = () => getUserTypeFromToken() === 'customer';

  const toggleSubscriptionExpand = (subscriptionKey) => {
    setExpandedSubscriptions(prev => ({
      ...prev,
      [subscriptionKey]: !prev[subscriptionKey]
    }));
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    const cleaned = phoneNumber.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
    }

    return phoneNumber;
  };


  const getOrderStatus = (st) => {
    switch (st) {
      case 'PENDING': return 'Pending';
      case 'CONFIRMED': return 'Confirmed';
      case 'COMPLETED': return 'Completed';
      default: return 'Pending';
    }
  };

  const isOrderExtended = (order) => {
    if (order.is_extended === true) return true;
    if (order.extension_weeks > 0) return true;
    if (order.extension_days > 0) return true;

    if (order.pickup_date && order.original_pickup_date) {
      const pickupDate = moment(order.pickup_date);
      const originalDate = moment(order.original_pickup_date);
      if (pickupDate.isValid() && originalDate.isValid() && pickupDate.isAfter(originalDate)) {
        return true;
      }
    }

    return false;
  };

  const renderPickupDateInfo = (order) => {

    if (order.order_type === 'storage') {
      return null;
    }

    const isExtended = isOrderExtended(order);
    const pickupDate = order?.pickup_date;

    const getOriginalPickupDate = () => {
      // For order list display, prefer backend original_pickup_date if available
      if (order?.original_pickup_date) {
        return order.original_pickup_date;
      }

      // Fallback calculation for older orders without original_pickup_date field
      if (pickupDate && isExtended) {
        const currentPickup = moment(pickupDate);
        const extensionWeeks = order?.extension_weeks || 0;
        const extensionDays = order?.extension_days || 0;

        const totalExtensionDays = (extensionWeeks * 7) + extensionDays;

        if (totalExtensionDays > 0) {
          const originalDate = currentPickup.clone().subtract(totalExtensionDays, 'days');
          return originalDate.format('YYYY-MM-DD');
        }
      }

      return null;
    };

    const originalPickupDate = getOriginalPickupDate();

    return (
      <>
        <div className="rental-order-detail-item rental-inline-item">
          <ClockCircleOutlined className="rental-detail-icon" />
          <span className="rental-detail-label">Pickup:</span>
          <span className="rental-detail-value">
            {pickupDate && moment(pickupDate).isValid()
              ? moment(pickupDate).format('MM/DD/YYYY')
              : 'N/A'}
          </span>
        </div>

        <div className="rental-extension-container">
          {isExtended ? (
            <div className="rental-extension-info-minimal">
              <div className="rental-extension-main-info">
                Pickup date extended from{' '}
                {originalPickupDate && moment(originalPickupDate).isValid()
                  ? moment(originalPickupDate).format('MMM DD, YYYY')
                  : 'original date'}{' '}
                to{' '}
                <span style={{ color: '#1890ff', fontWeight: '600' }}>
                  {pickupDate && moment(pickupDate).isValid()
                    ? moment(pickupDate).format('MMM DD, YYYY')
                    : 'new date'}
                </span>
              </div>
            </div>
          ) : (
            <div className="rental-extension-placeholder"></div>
          )}
        </div>
      </>
    );
  };

  const renderExtensionBadge = (order) => {
    const isExtended = isOrderExtended(order);
    if (!isExtended) return null;

    return (
      <span className="rental-extension-badge-minimal">
        EXTENDED
      </span>
    );
  };

  const renderStorageSubscriptionInfo = (order) => {
    if (order.order_type !== 'storage') {
      return null;
    }

    const subscriptionDetails = order.subscription_details;

    if (!subscriptionDetails) {
      return (
        <div className="rental-order-detail-item">
          <InboxOutlined className="rental-detail-icon" />
          <span className="rental-detail-label">Subscription:</span>
          <span className="rental-detail-value">No active subscription</span>
        </div>
      );
    }

    return (
      <>
        <div className="rental-order-detail-item rental-inline-item">
          <InboxOutlined className="rental-detail-icon" />
          <span className="rental-detail-label">Subscription:</span>
          <span className="rental-detail-value">
            {subscriptionDetails.status || 'Active'}
          </span>
        </div>

        {subscriptionDetails.start_date && (
          <div className="rental-order-detail-item rental-inline-item">
            <span className="rental-detail-label">Start Date:</span>
            <span className="rental-detail-value">
              {moment(subscriptionDetails.start_date).isValid()
                ? moment(subscriptionDetails.start_date).format('MM/DD/YYYY')
                : 'N/A'}
            </span>
          </div>
        )}

        {subscriptionDetails.next_billing_date && (
          <div className="rental-order-detail-item rental-inline-item">
            <span className="rental-detail-label">Next Billing:</span>
            <span className="rental-detail-value">
              {moment(subscriptionDetails.next_billing_date).isValid()
                ? moment(subscriptionDetails.next_billing_date).format('MM/DD/YYYY')
                : 'N/A'}
            </span>
          </div>
        )}

        {subscriptionDetails.amount && (
          <div className="rental-order-detail-item rental-inline-item">
            <span className="rental-detail-label">Monthly Amount:</span>
            <span className="rental-detail-value">
              ${subscriptionDetails.amount}/month
            </span>
          </div>
        )}

        {subscriptionDetails.plan && (
          <div className="rental-order-detail-item rental-inline-item">
            <span className="rental-detail-label">Plan:</span>
            <span className="rental-detail-value">
              {subscriptionDetails.plan}
            </span>
          </div>
        )}

        {subscriptionDetails.billing_cycle && (
          <div className="rental-order-detail-item rental-inline-item">
            <span className="rental-detail-label">Billing Cycle:</span>
            <span className="rental-detail-value">
              {subscriptionDetails.billing_cycle}
            </span>
          </div>
        )}
      </>
    );
  };


  useEffect(() => {
    if (customerData) setShowLoader(true);
  }, [customerData]);

  useEffect(() => {
    if (!isStorageCustomer()) {
      setSubscriptions({
        currentPage: 1,
        limit: 8,
        subscriptions: [],
        pages: 0
      });
    }
  }, []);

  useEffect(() => {
    const checkExtensionSuccess = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const successParam = urlParams.get('extension_success');
      const orderIdParam = urlParams.get('order_id');
      const amountParam = urlParams.get('amount');

      if (successParam === 'true' && orderIdParam && orders.orders.length > 0) {
        console.log('Extension success detected:', { orderIdParam, amountParam });

        const extendedOrder = orders.orders.find(order =>
          order.order_id === orderIdParam || order.order_number === orderIdParam
        );

        console.log('Found extended order:', extendedOrder);

        const successData = {
          orderId: orderIdParam,
          amount: amountParam
        };

        if (extendedOrder && extendedOrder.is_extended) {
          const getPreviousPickupDate = () => {
            // For success message, we want to show the immediate previous pickup date
            // Use the intended pickup date from URL to calculate correctly

            const urlParams = new URLSearchParams(window.location.search);
            const intendedPickupDateStr = urlParams.get('intended_pickup_date');
            const extensionWeeks = parseInt(urlParams.get('extension_weeks')) || 0;
            const extensionDays = parseInt(urlParams.get('extension_days')) || 0;

            console.log('Success message calculation (enhanced):', {
              intendedPickupDate: intendedPickupDateStr,
              extensionWeeks,
              extensionDays,
              currentPickup: extendedOrder.pickup_date
            });

            // Best approach: Use intended pickup date from URL and subtract extension
            if (intendedPickupDateStr && (extensionWeeks > 0 || extensionDays > 0)) {
              const intendedPickup = moment(intendedPickupDateStr, 'MM/DD/YYYY');
              const totalExtensionDays = (extensionWeeks * 7) + extensionDays;

              if (intendedPickup.isValid() && totalExtensionDays > 0) {
                const previousPickupDate = intendedPickup.clone().subtract(totalExtensionDays, 'days');
                console.log('Previous pickup date (calculated from intended date):', previousPickupDate.format('YYYY-MM-DD'));
                return previousPickupDate.format('YYYY-MM-DD');
              }
            }

            // Fallback 1: Use current pickup date with URL extension data
            if (extendedOrder.pickup_date && (extensionWeeks > 0 || extensionDays > 0)) {
              const currentPickup = moment(extendedOrder.pickup_date);
              const currentExtensionDays = (extensionWeeks * 7) + extensionDays;

              if (currentExtensionDays > 0) {
                const fallbackPreviousDate = currentPickup.clone().subtract(currentExtensionDays, 'days');
                console.log('Fallback 1: Previous pickup date from current pickup:', fallbackPreviousDate.format('YYYY-MM-DD'));
                return fallbackPreviousDate.format('YYYY-MM-DD');
              }
            }

            // Fallback 2: Use stored extension data from order
            if (extendedOrder.pickup_date) {
              const currentPickup = moment(extendedOrder.pickup_date);
              const totalStoredExtensionDays = ((extendedOrder.extension_weeks || 0) * 7) + (extendedOrder.extension_days || 0);

              if (totalStoredExtensionDays > 0) {
                const fallbackPreviousDate = currentPickup.clone().subtract(totalStoredExtensionDays, 'days');
                console.log('Fallback 2: Previous pickup date from stored data:', fallbackPreviousDate.format('YYYY-MM-DD'));
                return fallbackPreviousDate.format('YYYY-MM-DD');
              }
            }

            // Final fallback: use original_pickup_date if nothing else works
            console.log('Using final fallback: original_pickup_date');
            return extendedOrder.original_pickup_date || null;
          };

          const previousDate = getPreviousPickupDate();

          successData.originalDate = previousDate && moment(previousDate).isValid()
            ? moment(previousDate).format('MMM DD, YYYY')
            : 'original date';
          successData.newDate = extendedOrder.pickup_date && moment(extendedOrder.pickup_date).isValid()
            ? moment(extendedOrder.pickup_date).format('MMM DD, YYYY')
            : 'new date';


          successData.extensionWeeks = extendedOrder.extension_weeks || 0;
          successData.extensionDays = extendedOrder.extension_days || 0;
          successData.extensionType = extendedOrder.extension_type;
        } else {
          console.log('Order not found or not extended, using default values');
          successData.originalDate = 'original date';
          successData.newDate = 'new date';
          successData.extensionWeeks = 0;
          successData.extensionDays = 0;
          successData.extensionType = null;
        }

        console.log('Showing success modal with data:', successData);

        setExtensionSuccess({
          show: true,
          data: successData
        });


        const newUrl = window.location.pathname + '?tab=account';
        window.history.replaceState({}, '', newUrl);
      }
    };


    if (orders.orders.length > 0) {
      checkExtensionSuccess();
    }
  }, [orders.orders, window.location.search]);

  const getSubscriptions = async () => {
    const userType = getUserTypeFromToken();

    try {
      let response;

      if (userType === "customer") {
        console.log('Loading subscriptions for storage customer...');
        response = await getCustomerStorageSubscriptions(customer.id, {
          offset: subscriptions?.currentPage == 1 ? undefined : (subscriptions?.currentPage - 1) * subscriptions?.limit,
          limit: subscriptions?.limit
        });
      } else if (userType === "rental_customer" && orders.hasStorageAccount) {
        console.log('Loading subscriptions for rental user with storage account...');
        try {
          const email = customerData?.email || customer?.email || customer?.custormerData?.email;
          console.log('Email for subscription lookup:', email);

          if (!email) {
            console.warn('No email available for subscription fetch');
            return;
          }

          const emailCheckResponse = await getCustomerByEmail(email);

          if (emailCheckResponse?.data?.success && emailCheckResponse?.data?.data) {
            const storageCustomerId = emailCheckResponse.data.data.id;
            console.log('Found storage customer ID:', storageCustomerId);

            console.log('Fetching subscriptions for storage customer ID:', storageCustomerId);
            try {
              response = await getCustomerStorageSubscriptions(storageCustomerId, {
                offset: subscriptions?.currentPage == 1 ? undefined : (subscriptions?.currentPage - 1) * subscriptions?.limit,
                limit: subscriptions?.limit
              });
              console.log('Subscription API response:', response?.data);
              console.log('Raw response object:', response);
            } catch (subscriptionError) {
              console.error('Error calling subscription API:', subscriptionError);
              return;
            }
          } else {
            console.warn('No storage customer found for email:', email);
          }
        } catch (error) {
          console.warn('Could not fetch subscriptions for rental user:', error);
          return;
        }
      } else {
        console.log('Not loading subscriptions - conditions not met');
        console.log('userType:', userType, 'hasStorageAccount:', orders.hasStorageAccount);
        return;
      }

      if (response?.data?.success) {
        setSubscriptions((prev) => ({
          ...prev,
          pages: Math.ceil(response?.data.data.totalCount / subscriptions?.limit),
          subscriptions: subscriptions?.currentPage == 1 ? [...response.data.data.subscriptions] : [...subscriptions.subscriptions, ...response.data.data.subscriptions] || []
        }));
      }
    } catch (error) {
      console.error('Error fetching subscriptions:', error);
    }
  };

  const getOrders = async () => {
    const userType = getUserTypeFromToken();
    const customerId = customer.id;

    try {
      let response;

      if (userType === "customer") {

        response = await getCustomerStorageOrders(customerId, {
          offset: orders?.currentPage == 1 ? undefined : (orders?.currentPage - 1) * orders?.limit,
          limit: orders?.limit
        });

        if (response?.data?.success) {
          setOrders((prev) => ({
            ...prev,
            pages: Math.ceil(response?.data?.data?.totalCount / orders?.limit),
            orders: orders?.currentPage == 1
              ? [...response.data.data.orders]
              : [...prev.orders, ...response.data.data.orders] || [],
            storageOrders: [],
            hasStorageAccount: false
          }));

          if (handleStorageAccountUpdate) {
            handleStorageAccountUpdate(false);
          }
        }
      }
      else if (userType === "rental_customer" || userType === "both_customer") {

        let rentalOrders = [];
        let rentalTotalCount = 0;

        try {
          response = await packageOrderData(customerId, {
            limit: orders?.limit,
            offset: orders?.currentPage == 1 ? undefined : (orders?.currentPage - 1) * orders?.limit
          });

          console.log('=== RENTAL ORDERS API DEBUG ===');
          console.log('Response:', response);
          console.log('response.data:', response?.data);
          console.log('response.data.data:', response?.data?.data);
          console.log('response.data.data.orders:', response?.data?.data?.orders);

          if (response?.data?.status === 'success') {
            rentalOrders = response.data.data.orders || [];
            rentalTotalCount = response.data.data.totalCount || 0;
            console.log('✓ Orders found:', rentalOrders.length);
            console.log('✓ rentalOrders:', rentalOrders);
          } else {
            console.log('✗ Success check failed');
          }
        } catch (apiError) {
          if (apiError.response?.status === 404) {
            console.warn("packageOrderData endpoint not found");
          } else {
            throw apiError;
          }
        }


        let storageOrders = [];
        let storageTotalCount = 0;
        let hasStorageAccount = false;

        try {

          const email = customerData?.email || customer?.email || customer?.custormerData?.email;


          if (!email || email === 'undefined') {
            console.warn('No valid email found in any source, skipping storage account check');
            throw new Error('No email available');
          }

          console.log('Making API call with email:', email);
          const emailCheckResponse = await getCustomerByEmail(email);

          console.log('Email check API response:', emailCheckResponse?.data);

          if (emailCheckResponse?.data?.success && emailCheckResponse?.data?.data) {
            hasStorageAccount = true;
            const storageCustomerId = emailCheckResponse.data.data.id;
            console.log('Found storage customer with ID:', storageCustomerId);


            try {
              const storageResponse = await getStorageOrdersByEmail(email, {
                offset: orders?.storageCurrentPage == 1 ? undefined : (orders?.storageCurrentPage - 1) * orders?.limit,
                limit: orders?.limit
              });

              if (storageResponse?.data?.success) {
                const fetchedStorageOrders = storageResponse.data.data.orders || [];
                storageTotalCount = storageResponse.data.data.totalCount || 0;

                const typedStorageOrders = fetchedStorageOrders.map(order => ({
                  ...order,
                  order_type: 'storage'
                }));

                if (orders?.storageCurrentPage == 1) {
                  storageOrders = typedStorageOrders;
                } else {
                  const existingOrderIds = new Set((orders.storageOrders || []).map(order => order.order_id || order.order_number));
                  const newOrders = typedStorageOrders.filter(order => !existingOrderIds.has(order.order_id || order.order_number));
                  storageOrders = [...(orders.storageOrders || []), ...newOrders];
                }
              }
            } catch (storageOrderError) {
              console.warn('Could not fetch storage orders via email endpoint:', storageOrderError);
            }
          }
        } catch (emailError) {
          console.warn("Could not check for storage account:", emailError);
        }


        const markedRentalOrders = rentalOrders.map(order => ({
          ...order,
          order_type: 'rental'
        }));


        const finalOrders = orders?.currentPage == 1
          ? [...markedRentalOrders]
          : [...orders.orders.filter(order => order.order_type === 'rental' || !order.order_type), ...markedRentalOrders];

        setOrders((prev) => ({
          ...prev,
          pages: Math.ceil(rentalTotalCount / orders?.limit),
          orders: finalOrders,
          storageOrders: storageOrders,
          storagePages: Math.ceil(storageTotalCount / orders?.limit),
          storageTotalCount: storageTotalCount,
          hasStorageAccount: hasStorageAccount
        }));

        if (handleStorageAccountUpdate) {
          handleStorageAccountUpdate(hasStorageAccount);
        }
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      if (error.response?.status !== 404) {
        message.error("Failed to fetch orders. Please try again.");
      }
    }
  };

  const getAlaCarteOrders = async () => {
    const customerId = customer.id;

    console.log('Fetching à la carte orders for customer ID:', customerId);

    try {
      setAlaCarteOrders(prev => ({ ...prev, loading: true }));

      const response = await getCustomerAlaCarteOrders(customerId);

      if (response?.data?.success) {
        const orders = response.data.orders || [];

        console.log('À La Carte Orders fetched:', orders);

        const byRentalOrder = {};
        orders.forEach(order => {
          if (order.linked_rental_order?.order_id) {
            const rentalId = order.linked_rental_order.order_id;
            if (!byRentalOrder[rentalId]) {
              byRentalOrder[rentalId] = [];
            }
            byRentalOrder[rentalId].push(order);
          }
        });

        console.log('Grouped by rental order:', byRentalOrder);

        setAlaCarteOrders({
          orders: orders,
          totalCount: response.data.count || 0,
          loading: false,
          byRentalOrder: byRentalOrder
        });
      } else {
        setAlaCarteOrders(prev => ({
          ...prev,
          orders: [],
          totalCount: 0,
          loading: false,
          byRentalOrder: {}
        }));
      }
    } catch (error) {
      console.error("Error fetching à la carte orders:", error);
      setAlaCarteOrders(prev => ({
        ...prev,
        orders: [],
        totalCount: 0,
        loading: false,
        byRentalOrder: {}
      }));
    }
  };

  useEffect(() => {
    if (customerData) {
      getOrders();
      getAlaCarteOrders();
    }
  }, [orders?.currentPage, customerData]);


  useEffect(() => {
    if (customerData && orders.hasStorageAccount) {
      getOrders();
    }
  }, [orders?.storageCurrentPage]);

  useEffect(() => {
    if (isStorageCustomer()) {
      getSubscriptions();
    }
  }, [subscriptions?.currentPage]);

  const handleSubPagination = (page) => {
    setSubscriptions(prev => ({
      ...prev,
      currentPage: page
    }))
  }

  const handleOrdersPagination = (page) => {
    setOrders(prev => ({
      ...prev,
      currentPage: page
    }))
  }

  const handleStorageOrdersPagination = (page) => {
    setOrders(prev => ({
      ...prev,
      storageCurrentPage: page
    }))
  }

  const openModal = (modalName, data = {}) => {
    setModalStates(prev => ({ ...prev, [modalName]: true }));
    if (data) {
      setRentalData(prev => ({ ...prev, ...data }));
    }
  };

  const closeModal = (modalName) => {
    setModalStates(prev => ({ ...prev, [modalName]: false }));
  };

  const handleDateChangeRequest = (order) => {
    openModal('dateChange', { selectedOrder: order });
  };

  const handleExtendRentalRequest = async (order) => {
    const customerId = customer.id;

    setRentalData(prev => ({
      ...prev,
      selectedExtendOrder: order,
      selectedOrderDetails: null,
      loadingOrderDetails: true
    }));
    openModal('extendRental');

    try {
      const response = await packageOrderData(customerId, {
        limit: 100,
        offset: 0
      });

      if (response?.data?.success || response?.data?.status === 'success') {
        const ordersData = response.data.data.orders || [];
        const specificOrder = ordersData.find(o => o.order_id === order.order_id || o.order_number === order.order_number);

        if (specificOrder) {
          setRentalData(prev => ({
            ...prev,
            selectedOrderDetails: specificOrder,
            loadingOrderDetails: false
          }));
        } else {
          message.error('Order details not found');
          setRentalData(prev => ({ ...prev, loadingOrderDetails: false }));
          closeModal('extendRental');
          return;
        }
      } else {
        message.error('Failed to load order details');
        setRentalData(prev => ({ ...prev, loadingOrderDetails: false }));
        closeModal('extendRental');
        return;
      }
    } catch (error) {
      console.error('Error fetching order details:', error);
      message.error('Failed to load order details');
      setRentalData(prev => ({ ...prev, loadingOrderDetails: false }));
      closeModal('extendRental');
      return;
    }
  };

  const editCustomer = () => {
    openModal('editCustomer');
  };

  const handleExtensionSuccess = () => {
    setOrders(prev => ({
      ...prev,
      currentPage: 1,
      orders: []
    }));

    message.success('Rental period extended successfully!');
  };

  const handleExtensionSuccessClose = () => {
    setExtensionSuccess({
      show: false,
      data: null
    });
  };


  const handleOrderUpdateWithRefresh = async () => {
    console.log('Refreshing customer data and orders after update...');

    try {

      if (handleOrderUpdate && typeof handleOrderUpdate === 'function') {
        await handleOrderUpdate();
        console.log('Customer data refreshed successfully');
      }


      setOrders(prev => ({
        ...prev,
        currentPage: 1,
        orders: []
      }));


      await getOrders();
      console.log('Orders refreshed successfully');

    } catch (error) {
      console.error('Error refreshing data after order update:', error);
    }
  };

  const renderAddressInfo = () => {
    const userType = getUserTypeFromToken();
    const isRentalCustomer = userType === 'rental_customer' || userType === 'both_customer';

    if (isRentalCustomer) {
      return (
        <>
          {/* <div className="rental-info-item">
            <EnvironmentOutlined className="rental-info-icon" />
            <div className="rental-info-content">
              <span className="rental-info-label">Delivery Address:</span>
              <span className="rental-info-value">
                {customerData?.custormerData?.delivery_address?.address
                  ? customerData?.custormerData?.delivery_address?.address
                  : '-'}
              </span>
            </div>
          </div> */}
          {/* <div className="rental-info-item">
            <HomeOutlined className="rental-info-icon" />
            <div className="rental-info-content">
              <span className="rental-info-label">Delivery Apt. #:</span>
              <span className="rental-info-value">
                {customerData?.custormerData?.delivery_address?.apt_number
                  ? customerData?.custormerData?.delivery_address?.apt_number
                  : '-'}
              </span>
            </div>
          </div> */}
          {/* <div className="rental-info-item">
            <EnvironmentOutlined className="rental-info-icon" />
            <div className="rental-info-content">
              <span className="rental-info-label">Pickup Address:</span>
              <span className="rental-info-value">
                {customerData?.custormerData?.pickup_address?.address
                  ? customerData?.custormerData?.pickup_address?.address
                  : '-'}
              </span>
            </div>
          </div> */}
          {/* <div className="rental-info-item">
            <HomeOutlined className="rental-info-icon" />
            <div className="rental-info-content">
              <span className="rental-info-label">Pickup Apt. #:</span>
              <span className="rental-info-value">
                {customerData?.custormerData?.pickup_address?.apt_number
                  ? customerData?.custormerData?.pickup_address?.apt_number
                  : '-'}
              </span>
            </div>
          </div> */}
        </>
      );
    } else {
      return (
        <>
          <p className="mb-0 pb-1 info-details">
            <span className="fw-400">Address:</span>
            <span className="fw-600">
              {' '}
              {customerData?.custormerData?.address
                ? customerData?.custormerData?.address
                : '-'}
            </span>
          </p>
          <p className="mb-0 pb-1 info-details">
            <span className="fw-400">Apt. #:</span>
            <span className="fw-600">
              {' '}
              {customerData?.custormerData?.apt_number
                ? customerData?.custormerData?.apt_number
                : '-'}
            </span>
          </p>
          <p className="mb-0 pb-1 info-details">
            <span className="fw-400">Zip Code:</span>
            <span className="fw-600">
              {' '}
              {customerData?.custormerData?.zipcode
                ? customerData?.custormerData?.zipcode
                : '-'}
            </span>
          </p>
        </>
      );
    }
  };

  const userType = getUserTypeFromToken();
  const isRentalCustomer = userType === 'rental_customer' || userType === 'both_customer';

  if (isRentalCustomer) {
    return (
      <>
        <Spin spinning={!showLoader} tip={'fetching user data.....'}>
          <div className="rental-main-container">
            <div className="rental-content-wrapper">
              {/* Left Column: Personal Details + Quick Actions */}
              <div className="rental-left-column">
                {/* Personal Details Section */}
                <div className="rental-personal-section">
                  <div className="rental-personal-card">
                    <div className="rental-card-header">
                      <h3 className="rental-card-title">Personal Details</h3>
                      <Button
                        type="text"
                        size="small"
                        className="rental-edit-btn"
                        onClick={() => editCustomer()}
                        icon={<EditOutlined />}>
                        Edit
                      </Button>
                    </div>
                    <div className="rental-card-content">
                      <div className="rental-info-item">
                        <UserOutlined className="rental-info-icon" />
                        <div className="rental-info-content">
                          <span className="rental-info-label">Name:</span>
                          <span className="rental-info-value">{customerData?.name}</span>
                        </div>
                      </div>

                      <div className="rental-info-item">
                        <MailOutlined className="rental-info-icon" />
                        <div className="rental-info-content">
                          <span className="rental-info-label">Email:</span>
                          <span className="rental-info-value">{customerData?.email}</span>
                        </div>
                      </div>

                      <div className="rental-info-item">
                        <PhoneOutlined className="rental-info-icon" />
                        <div className="rental-info-content">
                          <span className="rental-info-label">Mobile:</span>
                          <span className="rental-info-value">
                            {customerData?.custormerData?.mobile ? customerData?.custormerData?.mobile : '-'}
                          </span>
                        </div>
                      </div>

                      <div className="rental-info-item">
                        <PhoneOutlined className="rental-info-icon" />
                        <div className="rental-info-content">
                          <span className="rental-info-label">Secondary Mobile Number:</span>
                          <span className="rental-info-value">
                            {customerData?.custormerData?.secondary_mobile
                              ? customerData?.custormerData?.secondary_mobile
                              : 'N/A'}
                          </span>
                        </div>
                      </div>

                      {renderAddressInfo()}
                    </div>
                  </div>
                </div>

                {/* Quick Actions Section */}
                <div className="rental-personal-section">
                  <div className="rental-personal-card">
                    <div className="rental-card-header">
                      <h3 className="rental-card-title">Quick Actions</h3>
                    </div>
                    <div className="rental-card-content">
                      <p className="rental-card-subtitle">Place a new moving box rental order or try our storage service.</p>
                      <div className="quick-actions-buttons">
                        <Button
                          type="primary"
                          size="small"
                          className="quick-action-button storage-boxes-btn"
                          onClick={() => {
                            console.log('Storage Boxes clicked');
                            const mobile = customerData?.custormerData?.mobile;
                            const secondaryMobile = customerData?.custormerData?.secondary_mobile;
                            let url = '/storage-box/buying-box?from=quick-actions';
                            if (mobile) {
                              const formattedMobile = formatPhoneNumber(mobile);
                              url += `&mobile=${encodeURIComponent(formattedMobile)}`;
                            }
                            if (secondaryMobile) {
                              const formattedSecondaryMobile = formatPhoneNumber(secondaryMobile);
                              url += `&secondary_mobile=${encodeURIComponent(formattedSecondaryMobile)}`;
                            }
                            window.location.href = url;
                          }}>
                          Order Storage Boxes
                        </Button>

                        <Button
                          type="primary"
                          size="small"
                          className="quick-action-button moving-boxes-btn"
                          onClick={() => {
                            console.log('Moving Boxes clicked');
                            const mobile = customerData?.custormerData?.mobile;
                            const secondaryMobile = customerData?.custormerData?.secondary_mobile;
                            let url = '/packages?from=quick-actions';
                            if (mobile) {
                              const formattedMobile = formatPhoneNumber(mobile);
                              url += `&mobile=${encodeURIComponent(formattedMobile)}`;
                            }
                            if (secondaryMobile) {
                              const formattedSecondaryMobile = formatPhoneNumber(secondaryMobile);
                              url += `&secondary_mobile=${encodeURIComponent(formattedSecondaryMobile)}`;
                            }
                            window.location.href = url;
                          }}>
                          Order Moving Boxes
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* À La Carte Order Section */}
                <div className="rental-personal-section">
                  <div className="rental-personal-card">
                    <div className="rental-card-header">
                      <h3 className="rental-card-title">Need some extra boxes or supplies?</h3>
                    </div>
                    <div className="rental-card-content">
                      <p className="rental-card-subtitle">Place an a la carte order if you would like to order individual boxes and supplies as needed.</p>
                      <div className="quick-actions-buttons">
                        <Button
                          type="primary"
                          size="small"
                          className="quick-action-button alacarte-btn"
                          style={{ backgroundColor: '#EE1B24', borderColor: '#EE1B24' }}
                          onClick={() => {
                            console.log('À La Carte Order clicked');
                            navigate('/alacarte-order');
                          }}>
                          Order À La Carte
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column: Orders Section */}
              <div className="rental-orders-section">
                <div className="most-recent-orders-section">
                  <div className="rental-orders-card">
                    <div className="rental-orders-header">
                      <div className="rental-orders-title-section">
                        <h3 className="rental-orders-title">Most Recent Orders</h3>
                        <p className="rental-orders-subtitle">
                          Your latest rental and storage orders
                        </p>
                      </div>
                    </div>

                    <div className="rental-orders-grid">
                      {(() => {
                        const allowedStatuses = ['COMPLETED', 'CONFIRMED', 'PENDING'];

                        const rentalOrders = (orders?.orders?.filter(order =>
                          allowedStatuses.includes(order.status) && (order.order_type === 'rental' || !order.order_type)
                        ) || [])
                          .sort((a, b) => new Date(b.order_date || b.created_on) - new Date(a.order_date || a.created_on))
                          .slice(0, 1);

                        const storageOrders = (orders?.storageOrders?.filter(order =>
                          allowedStatuses.includes(order.status)
                        ) || [])
                          .sort((a, b) => new Date(b.order_date || b.created_on) - new Date(a.order_date || a.created_on))
                          .slice(0, 1);

                        const allRecentOrders = [...rentalOrders, ...storageOrders]
                          .sort((a, b) => new Date(b.order_date || b.created_on) - new Date(a.order_date || a.created_on))
                          .slice(0, 4);

                        if (allRecentOrders.length === 0) {
                          return (
                            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px' }}>
                              <p>No recent orders found</p>
                            </div>
                          );
                        }

                        return allRecentOrders.map((obj, index) => (
                          <div key={`recent-${index}`} className={`rental-order-card ${isOrderExtended(obj) ? 'extended-order' : ''} ${obj.order_type ? obj.order_type + '-order' : ''}`}>
                            {renderExtensionBadge(obj)}
                            <div className="rental-order-header">
                              <h4 className="rental-order-id">
                                {obj.order_number || obj.order_id} -
                                <span className={`rental-order-status rental-status-${obj.status.toLowerCase()}`}>
                                  {getOrderStatus(obj.status)}
                                </span>
                              </h4>
                            </div>

                            <div className="rental-order-details">
                              <div className="rental-order-detail-item">
                                <span className="rental-detail-label">Order Date:</span>
                                <span className="rental-detail-value">
                                  {moment(obj.order_date || obj.created_on).isValid()
                                    ? moment(obj.order_date || obj.created_on).format('MM/DD/YYYY')
                                    : 'N/A'}
                                </span>
                              </div>

                              <div className="rental-order-detail-item rental-inline-item">
                                <CalendarOutlined className="rental-detail-icon" />
                                <span className="rental-detail-label">Delivery:</span>
                                <span className="rental-detail-value">
                                  {(() => {
                                    const deliveryDate = obj?.delivery_details?.delivery_date || obj?.delivery_date;
                                    return deliveryDate && moment(deliveryDate).isValid()
                                      ? moment(deliveryDate).format('MM/DD/YYYY')
                                      : 'N/A';
                                  })()}
                                </span>
                              </div>

                              {renderPickupDateInfo(obj)}

                              {obj.order_type === 'storage' && renderStorageSubscriptionInfo(obj)}
                            </div>

                            {obj.order_type === 'rental' && (
                              <div className="rental-order-actions">
                                <Button
                                  type="primary"
                                  size="small"
                                  className="rental-action-btn rental-change-date-btn"
                                  onClick={() => handleDateChangeRequest(obj)}
                                  disabled={
                                    moment().isAfter(moment(obj?.delivery_details?.delivery_date, 'YYYY-MM-DD')) &&
                                    moment().isAfter(moment(obj?.pickup_date))
                                  }
                                  icon={<CalendarOutlined />}>
                                  Change Date/Address
                                </Button>

                                <Button
                                  type="primary"
                                  size="small"
                                  className="rental-action-btn rental-extend-btn"
                                  onClick={() => handleExtendRentalRequest(obj)}
                                  disabled={
                                    moment().isAfter(moment(obj?.delivery_details?.delivery_date, 'YYYY-MM-DD')) &&
                                    moment().isAfter(moment(obj?.pickup_date))
                                  }
                                  icon={<ClockCircleOutlined />}>
                                  Extend Rental
                                </Button>
                              </div>
                            )}
                          </div>
                        ));
                      })()}
                    </div>
                  </div>
                </div>
                {/* Orders Section - Tabs Layout */}
                <div className="rental-orders-tabs-container">
                  <Tabs defaultActiveKey="rental" className="rental-orders-tabs">
                    <TabPane tab="Rental Orders" key="rental">
                      <div className="rental-orders-card">
                        <div className="rental-orders-header">
                          <div className="rental-orders-title-section">
                            <h3 className="rental-orders-title">Your Rental Orders</h3>
                            <p className="rental-orders-subtitle">
                              Manage your Moving Box Rental Orders and Extensions
                            </p>
                          </div>
                        </div>

                        <div className="rental-orders-grid">
                          {(() => {
                            const allowedStatuses = ['COMPLETED', 'CONFIRMED', 'PENDING'];
                            const rentalOrders = orders?.orders?.filter(order =>
                              allowedStatuses.includes(order.status) && (order.order_type === 'rental' || !order.order_type)
                            ) || [];

                            if (rentalOrders.length === 0) {
                              return (
                                <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px' }}>
                                  <p>No rental orders found</p>
                                </div>
                              );
                            }

                            return rentalOrders.map((obj, index) => {
                              const orderId = obj.order_number || obj.order_id;
                              console.log('Rental Order ID:', orderId, 'Has À La Carte:', alaCarteOrders.byRentalOrder[orderId]);

                              return (
                                <div key={index} className={`rental-order-card ${isOrderExtended(obj) ? 'extended-order' : ''} ${obj.order_type ? obj.order_type + '-order' : ''}`}>
                                  {renderExtensionBadge(obj)}
                                  <div className="rental-order-header">
                                    <h4 className="rental-order-id">
                                      {obj.order_number || obj.order_id} -
                                      <span className={`rental-order-status rental-status-${obj.status.toLowerCase()}`}>
                                        {getOrderStatus(obj.status)}
                                      </span>
                                    </h4>
                                  </div>

                                  <div className="rental-order-details">
                                    <div className="rental-order-detail-item">
                                      <span className="rental-detail-label">Order Date:</span>
                                      <span className="rental-detail-value">
                                        {moment(obj.order_date || obj.created_on).isValid()
                                          ? moment(obj.order_date || obj.created_on).format('MM/DD/YYYY')
                                          : 'N/A'}
                                      </span>
                                    </div>

                                    <div className="rental-order-detail-item rental-inline-item">
                                      <CalendarOutlined className="rental-detail-icon" />
                                      <span className="rental-detail-label">Delivery:</span>
                                      <span className="rental-detail-value">
                                        {(() => {
                                          const deliveryDate = obj?.delivery_details?.delivery_date || obj?.delivery_date;
                                          return deliveryDate && moment(deliveryDate).isValid()
                                            ? moment(deliveryDate).format('MM/DD/YYYY')
                                            : 'N/A';
                                        })()}
                                      </span>
                                    </div>

                                    {renderPickupDateInfo(obj)}
                                  </div>

                                  <div className="rental-order-actions">
                                    <Button
                                      type="primary"
                                      size="small"
                                      className="rental-action-btn rental-change-date-btn"
                                      onClick={() => handleDateChangeRequest(obj)}
                                      disabled={
                                        moment().isAfter(moment(obj?.delivery_details?.delivery_date, 'YYYY-MM-DD')) &&
                                        moment().isAfter(moment(obj?.pickup_date))
                                      }
                                      icon={<CalendarOutlined />}>
                                      Change Date/Address
                                    </Button>

                                    <Button
                                      type="primary"
                                      size="small"
                                      className="rental-action-btn rental-extend-btn"
                                      onClick={() => handleExtendRentalRequest(obj)}
                                      disabled={
                                        moment().isAfter(moment(obj?.delivery_details?.delivery_date, 'YYYY-MM-DD')) &&
                                        moment().isAfter(moment(obj?.pickup_date))
                                      }
                                      icon={<ClockCircleOutlined />}>
                                      Extend Rental
                                    </Button>
                                  </div>

                                  {/* À La Carte Orders Collapse */}
                                  {alaCarteOrders.byRentalOrder[obj.order_number || obj.order_id] && alaCarteOrders.byRentalOrder[obj.order_number || obj.order_id].length > 0 && (
                                    <div style={{ marginTop: '12px', borderTop: '1px solid #e8e8e8', paddingTop: '12px' }}>
                                      <Collapse
                                        ghost
                                        expandIconPosition="end"
                                        className="alacarte-collapse"
                                      >
                                        <Panel
                                          header={
                                            <div className="alacarte-header">
                                              <span>
                                                {alaCarteOrders.byRentalOrder[obj.order_number || obj.order_id].length} - À La Carte {alaCarteOrders.byRentalOrder[obj.order_number || obj.order_id].length === 1 ? 'Order' : 'Orders'}
                                              </span>
                                            </div>
                                          }
                                          key="1"
                                        >
                                          <div style={{ marginTop: '8px' }}>
                                            {alaCarteOrders.byRentalOrder[obj.order_number || obj.order_id].map((order, idx) => (
                                              <div key={idx} className="alacarte-order-card">
                                                {/* Order Header */}
                                                <div className="alacarte-order-header">
                                                  <div className="alacarte-order-header-content">
                                                    <div>
                                                      <h4 className="alacarte-order-title">
                                                        Order #{order.order_id}
                                                      </h4>
                                                    </div>
                                                    <div className={`alacarte-status-badge ${['comp', 'com', 'completed'].includes(order.status?.toLowerCase()) ? 'alacarte-status-completed' : 'alacarte-status-pending'}`}>
                                                      {['comp', 'com', 'completed'].includes(order.status?.toLowerCase()) ? 'Completed' : order.status?.toLowerCase() === 'pen' ? 'Pending' : order.status?.toLowerCase() === 'cnf' ? 'Confirmed' : order.status}
                                                    </div>
                                                  </div>
                                                </div>

                                                {/* Cart Items */}
                                                {/* <div className="alacarte-items-section">
                                        <p className="alacarte-items-title">
                                          Cart Items:
                                        </p>
                                        {order.cart_items && order.cart_items.length > 0 ? (
                                          <div className="alacarte-items-list">
                                            {order.cart_items.map((item, i) => (
                                              <div key={i} className="alacarte-item">
                                                <span className="alacarte-item-name">
                                                  {item.quantity}x {item.product_name}
                                                </span>
                                                <span className="alacarte-item-price">
                                                  ${item.total_price.toFixed(2)}
                                                </span>
                                              </div>
                                            ))}
                                          </div>
                                        ) : (
                                          <p className="alacarte-no-items">No items</p>
                                        )}
                                      </div> */}

                                                {/* Delivery and Pickup Dates */}
                                                {(order.delivery_info || order.pickup_info) && (
                                                  <div className="alacarte-dates-list">
                                                    {order.delivery_info && (
                                                      <div className="alacarte-date-item">
                                                        <span className="alacarte-date-label">Delivery</span>
                                                        <span className="alacarte-date-value">
                                                          {moment(order.delivery_info.delivery_date).format('MMM DD, YYYY')}
                                                        </span>
                                                      </div>
                                                    )}

                                                    {order.pickup_info && (
                                                      <div className="alacarte-date-item">
                                                        <span className="alacarte-date-label">Pickup</span>
                                                        <span className="alacarte-date-value">
                                                          {moment(order.pickup_info.pickup_date).format('MMM DD, YYYY')}
                                                        </span>
                                                      </div>
                                                    )}
                                                  </div>
                                                )}

                                                {/* Total */}
                                                {/* <div className="alacarte-total-section">
                                        <span className="alacarte-total-label">Total Amount:</span>
                                        <span className="alacarte-total-amount">
                                          ${order.total ? order.total.toFixed(2) : '0.00'}
                                        </span>
                                      </div> */}
                                              </div>
                                            ))}
                                          </div>
                                        </Panel>
                                      </Collapse>
                                    </div>
                                  )}
                                </div>
                              );
                            });
                          })()}
                        </div>

                        {orders?.pages > 1 && (
                          <div className="rental-pagination">
                            {orders?.currentPage > 1 && (
                              <p className="mb-0 show-more-btn mr-2" onClick={() => handleOrdersPagination(1)}>
                                show less <UpOutlined size={'small'} />
                              </p>
                            )}
                            {orders?.currentPage < orders.pages && (
                              <p className="mb-0 show-more-btn ml-2" onClick={() => handleOrdersPagination(orders?.currentPage + 1)}>
                                show more <DownOutlined size={'small'} />
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    </TabPane>

                    {orders.hasStorageAccount && (
                      <TabPane tab="Storage Orders" key="storage">
                        <div className="rental-orders-card">
                          <div className="rental-orders-header">
                            <div className="rental-orders-title-section">
                              <h3 className="rental-orders-title">Your Storage Orders</h3>
                              <p className="rental-orders-subtitle">
                                Manage your Storage Orders and Subscriptions
                              </p>
                            </div>
                            <div className="rental-orders-action-section">
                              <Button
                                type="primary"
                                size="small"
                                className="rental-action-btn inventory-access-btn"
                                onClick={() => {
                                  // Check current URL context to navigate correctly
                                  const currentPath = location.pathname;

                                  if (currentPath.includes('/storage-box/')) {
                                    // Already in storage-box context, use React Router
                                    navigate('/storage-box/my-account?tab=inventory');
                                  } else {
                                    // Cross-context navigation: force full page navigation
                                    // This ensures proper application context switch
                                    window.location.href = '/storage-box/my-account?tab=inventory';
                                  }
                                }}
                                style={{
                                  backgroundColor: '#ff4d4f',
                                  borderColor: '#ff4d4f',
                                  color: 'white'
                                }}>
                                Inventory
                              </Button>
                            </div>
                          </div>

                          <div className="rental-orders-grid">
                            {(() => {
                              const allowedStatuses = ['COMPLETED', 'CONFIRMED', 'PENDING'];
                              const storageOrders = orders?.storageOrders?.filter(order =>
                                allowedStatuses.includes(order.status)
                              ) || [];

                              if (storageOrders.length === 0) {
                                return (
                                  <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px' }}>
                                    <p>No storage orders found</p>
                                  </div>
                                );
                              }

                              return storageOrders.map((obj, index) => (
                                <div key={`storage-${index}`} className={`rental-order-card ${isOrderExtended(obj) ? 'extended-order' : ''} ${obj.order_type ? obj.order_type + '-order' : ''}`}>
                                  {renderExtensionBadge(obj)}
                                  <div className="rental-order-header">
                                    <h4 className="rental-order-id">
                                      {obj.order_number || obj.order_id} -
                                      <span className={`rental-order-status rental-status-${obj.status.toLowerCase()}`}>
                                        {getOrderStatus(obj.status)}
                                      </span>
                                    </h4>
                                  </div>

                                  <div className="rental-order-details">
                                    <div className="rental-order-detail-item">
                                      <span className="rental-detail-label">Order Date:</span>
                                      <span className="rental-detail-value">
                                        {moment(obj.order_date || obj.created_on).isValid()
                                          ? moment(obj.order_date || obj.created_on).format('MM/DD/YYYY')
                                          : 'N/A'}
                                      </span>
                                    </div>

                                    <div className="rental-order-detail-item rental-inline-item">
                                      <CalendarOutlined className="rental-detail-icon" />
                                      <span className="rental-detail-label">Delivery:</span>
                                      <span className="rental-detail-value">
                                        {(() => {
                                          const deliveryDate = obj?.delivery_details?.delivery_date || obj?.delivery_date;
                                          return deliveryDate && moment(deliveryDate).isValid()
                                            ? moment(deliveryDate).format('MM/DD/YYYY')
                                            : 'N/A';
                                        })()}
                                      </span>
                                    </div>

                                    {renderPickupDateInfo(obj)}

                                    {renderStorageSubscriptionInfo(obj)}
                                  </div>

                                </div>
                              ));
                            })()}
                          </div>

                          {orders?.storagePages > 1 && (
                            <div className="rental-pagination">
                              {orders?.storageCurrentPage > 1 && (
                                <p className="mb-0 show-more-btn mr-2" onClick={() => handleStorageOrdersPagination(1)}>
                                  show less <UpOutlined size={'small'} />
                                </p>
                              )}
                              {orders?.storageCurrentPage < orders.storagePages && (
                                <p className="mb-0 show-more-btn ml-2" onClick={() => handleStorageOrdersPagination(orders?.storageCurrentPage + 1)}>
                                  show more <DownOutlined size={'small'} />
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      </TabPane>
                    )}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </Spin>

        <EditCustomerModal
          open={modalStates.editCustomer}
          onClose={() => closeModal('editCustomer')}
          customerData={customerData}
          getUserData={getUserData}
          extraWork={extraWork}
        />

        <DateChangeModal
          open={modalStates.dateChange}
          onClose={() => closeModal('dateChange')}
          selectedOrder={rentalData.selectedOrder}
          onOrderUpdate={handleOrderUpdateWithRefresh}
        />

        <ExtendRentalModal
          open={modalStates.extendRental}
          onClose={() => closeModal('extendRental')}
          selectedOrder={rentalData.selectedExtendOrder}
          selectedOrderDetails={rentalData.selectedOrderDetails}
          loadingOrderDetails={rentalData.loadingOrderDetails}
          customer={customer}
          onOpenSummary={(summaryData) => {
            setRentalData(prev => ({ ...prev, extensionSummaryData: summaryData }));
            closeModal('extendRental');
            openModal('orderSummary');
          }}
          onSuccess={handleExtensionSuccess}
        />

        <RentalExtensionSummaryModal
          open={modalStates.orderSummary}
          onClose={() => closeModal('orderSummary')}
          summaryData={rentalData.extensionSummaryData}
          isProcessing={rentalData.isProcessing}
          selectedExtendOrder={rentalData.selectedExtendOrder}
          selectedOrderDetails={rentalData.selectedOrderDetails}
          customer={customer}
          onSuccess={handleExtensionSuccess}
        />

        <ExtensionSuccessModal
          open={extensionSuccess.show}
          onClose={handleExtensionSuccessClose}
          extensionData={extensionSuccess.data}
        />
      </>
    );
  }


  return (
    <>
      <Spin spinning={!showLoader} tip={'fetching user data.....'}>
        <div className="user-info py-3 px-3 s-color-black ">
          <Row className="align-items-start justify-content-center px-2">
            <Col
              xxl={2}
              xl={2}
              lg={3}
              md={4}
              sm={11}
              xs={11}
              className={`h-100 py-3 px-0 mx-3 cursor-pointer`}>
              <p className="mb-0 pb-1 info-title">Personal Details</p>
              <p className="mb-0 pb-1 info-details">
                <span className="fw-400">Name:</span>
                <span className="fw-600"> {customerData?.name}</span>
              </p>
              <p className="mb-0 pb-1 info-details">
                <span className="fw-400">Email:</span>
                <span className="fw-600"> {customerData?.email}</span>
              </p>
              <p className="mb-0 pb-1 info-details">
                <span className="fw-400">Mobile number:</span>
                <span className="fw-600">
                  {' '}
                  {customerData?.custormerData?.mobile ? customerData?.custormerData?.mobile : '-'}
                </span>
              </p>
              <p className="mb-0 pb-1 info-details">
                <span className="fw-400">Secondary Mobile Number:</span>
                <span className="fw-600">
                  {' '}
                  {customerData?.custormerData?.secondary_mobile
                    ? customerData?.custormerData?.secondary_mobile
                    : '-'}
                </span>
              </p>

              {renderAddressInfo()}

              <Button
                type="primary"
                size="large"
                className="mt-3 info-btn"
                ghost
                onClick={() => editCustomer()}>
                <i className="fa fa-edit mr-2"></i> Edit
              </Button>
            </Col>

            <hr className="info-divider w-100 px-3" />

            <Col
              xxl={2}
              xl={2}
              lg={3}
              md={4}
              sm={11}
              xs={11}
              className={`h-100 py-3 px-0 mx-3 cursor-pointer`}>
            </Col>
          </Row>
        </div>

        {getUserTypeFromToken() === 'customer' && (
          <div className="user-subscription s-color-black">
            <Container className="pt-4 pb-5 px-4">
              <p className="mb-0 pb-1 py-3 title fw-600">Your subscriptions</p>

              {subscriptions?.subscriptions?.length == 0 ? (
                <>
                  <p>No subscriptions found</p>
                </>
              ) : (
                <>
                  <Row>
                    {subscriptions?.subscriptions?.map((obj, index) => {
                      return (
                        <Col key={index} xxl={3} xl={3} lg={4} md={6} sm={12} xs={12}>
                          <div className="order-card">
                            <p className="order-info fw-400 mb-0 pb-1 fw-600 color-primary ">
                              {obj.order.order_number}
                            </p>
                            <p className="order-info fw-400 mb-0 pb-1">
                              Subscription start:{' '}
                              {moment(obj.start_date, 'YYYY-MM-DD').format('MM/DD/YYYY')}
                            </p>
                            <p className="order-info fw-400 mb-0 pb-1">
                              Next billing date:{' '}
                              {moment(obj.next_billing_date, 'YYYY-MM-DD').format('MM/DD/YYYY')}
                            </p>
                            <p className="order-info fw-400 mb-0 pb-1">
                              Amount: ${obj?.amount ? obj.amount : 0}/month
                            </p>
                          </div>
                        </Col>
                      );
                    })}
                    {subscriptions?.pages > 1 ? (
                      <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="d-flex justify-content-center align-items-center">
                          {
                            subscriptions?.currentPage > 1 ?
                              <p className="mb-0 show-more-btn mr-2" onClick={() => handleSubPagination(1)}>
                                show less <UpOutlined size={'small'} />
                              </p>
                              : ''
                          }
                          {subscriptions?.currentPage <= subscriptions.pages ? (
                            <p className="mb-0 show-more-btn ml-2" onClick={() => handleSubPagination(subscriptions?.currentPage + 1)}>
                              show more <DownOutlined size={'small'} />
                            </p>
                          ) : ''}
                        </div>
                      </Col>
                    ) : (
                      ''
                    )}
                  </Row>
                </>
              )}
            </Container>
          </div>
        )}

        <div className="user-orders s-color-black">
          <Container className="pt-4 pb-5 px-4">
            <p className="mb-0 pb-1 py-3 title fw-600">Your orders</p>

            {(() => {
              const allowedStatuses = ['COMPLETED', 'CONFIRMED', 'PENDING'];

              const filteredOrders = orders?.orders?.filter(order =>
                allowedStatuses.includes(order.status)
              ) || [];

              if (filteredOrders.length === 0) {
                return (
                  <>
                    <p>No orders found</p>
                  </>
                );
              }

              return (
                <>
                  <Row>
                    {filteredOrders.map((obj, index) => {
                      return (
                        <Col
                          key={index}
                          xxl={4}
                          xl={4}
                          lg={4}
                          md={6}
                          sm={12}
                          xs={12}
                          className="order-collapse">

                          <div>
                            <Collapse onChange={console.log} expandIconPosition={'end'}>
                              <Panel
                                showArrow={true}
                                header={
                                  <div className="order-card">
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div>
                                        <p className="order-info mb-0 pb-1 fw-600 color-primary ">
                                          {obj.order_number || obj.order_id} - {getOrderStatus(obj.status)}
                                        </p>
                                      </div>
                                    </div>

                                    <p className="order-info mb-0 pb-1 fw-400 s-color-black">
                                      Order Date:{' '}
                                      {moment(obj.order_date || obj.created_on).isValid()
                                        ? moment(obj.order_date || obj.created_on).format('MM/DD/YYYY')
                                        : 'N/A'}
                                    </p>

                                    <p className="order-info mb-0 pb-1 fw-400 s-color-black">
                                      Delivery date:{' '}
                                      {(() => {
                                        const deliveryDate = obj?.delivery_details?.delivery_date || obj?.delivery_date;
                                        return deliveryDate && moment(deliveryDate).isValid()
                                          ? moment(deliveryDate).format('MM/DD/YYYY')
                                          : 'N/A';
                                      })()}
                                    </p>
                                  </div>
                                }
                                key="1">
                              </Panel>
                            </Collapse>
                          </div>
                        </Col>
                      );
                    })}

                    {orders?.pages > 1 ? (
                      <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="d-flex justify-content-center align-items-center">
                          {orders?.currentPage > 1 ? (
                            <p className="mb-0 show-more-btn mr-2" onClick={() => handleOrdersPagination(1)}>
                              show less <UpOutlined size={'small'} />
                            </p>
                          ) : ''}
                          {orders?.currentPage <= orders.pages ? (
                            <p className="mb-0 show-more-btn ml-2" onClick={() => handleOrdersPagination(orders?.currentPage + 1)}>
                              show more <DownOutlined size={'small'} />
                            </p>
                          ) : ''}
                        </div>
                      </Col>
                    ) : ''}
                  </Row>
                </>
              );
            })()}
          </Container>
        </div>
      </Spin>

      <EditCustomerModal
        open={modalStates.editCustomer}
        onClose={() => closeModal('editCustomer')}
        customerData={customerData}
        getUserData={getUserData}
        extraWork={extraWork}
      />

      <DateChangeModal
        open={modalStates.dateChange}
        onClose={() => closeModal('dateChange')}
        selectedOrder={rentalData.selectedOrder}
        onOrderUpdate={handleOrderUpdateWithRefresh}
      />

      <ExtendRentalModal
        open={modalStates.extendRental}
        onClose={() => closeModal('extendRental')}
        selectedOrder={rentalData.selectedExtendOrder}
        selectedOrderDetails={rentalData.selectedOrderDetails}
        loadingOrderDetails={rentalData.loadingOrderDetails}
        customer={customer}
        onOpenSummary={(summaryData) => {
          setRentalData(prev => ({ ...prev, extensionSummaryData: summaryData }));
          closeModal('extendRental');
          openModal('orderSummary');
        }}
        onSuccess={handleExtensionSuccess}
      />

      <RentalExtensionSummaryModal
        open={modalStates.orderSummary}
        onClose={() => closeModal('orderSummary')}
        summaryData={rentalData.extensionSummaryData}
        isProcessing={rentalData.isProcessing}
        selectedExtendOrder={rentalData.selectedExtendOrder}
        selectedOrderDetails={rentalData.selectedOrderDetails}
        customer={customer}
        onSuccess={handleExtensionSuccess}
      />
    </>
  );
};

Account.propTypes = {
  customerData: PropTypes.any,
  getUserData: PropTypes.func,
  extraWork: PropTypes.any,
  handleOrderUpdate: PropTypes.func,
  handleStorageAccountUpdate: PropTypes.func
};

export default Account;